import { Box, Divider, SectionHelper, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import React from 'react';
export const CrossPageNotification = () => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Box, {
    margin: "14px 20px"
  }, /*#__PURE__*/React.createElement(SectionHelper, {
    appearance: "standard",
    size: "small"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin"
  }, t('accessibility-wizard.verticals-drill-in.content-section.page-specific-issues.cross-page-notification.content')))), /*#__PURE__*/React.createElement(Divider, null));
};
//# sourceMappingURL=cross-page-notification.js.map